import { NgModule } from '@angular/core';
import { FooterModule } from './footer/footer.module';
import { HeaderModule } from './header/header.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';



@NgModule({
  declarations: [PageNotFoundComponent],
  imports: [
    FooterModule,
    HeaderModule
  ],
  exports: [
    PageNotFoundComponent,
    FooterModule,
    HeaderModule
  ]
})
export class CoreModule { }
